import SourceHealthBadge from "../SourceHealthBadge";

const QualityBadge = ({ health }) => {
  return <SourceHealthBadge status={health || "unknown"} />;
};

export default QualityBadge;
